var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiagramMgt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h19.988v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 0.2,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.963 1.13a9 9 0 110 18 9 9 0 010-18zm0 1.35a7.65 7.65 0 100 15.3 7.65 7.65 0 000-15.3z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.538 5.309)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 3.938,
    width: 11.524,
    height: 1.496,
    rx: 0.748
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.777 5.434V8.65a.766.766 0 01-1.532 0V5.434h1.532zM6.235 5.434V8.65a.766.766 0 01-1.533 0V5.434h1.533zM9.692 5.434V8.65a.766.766 0 01-1.533 0V5.434h1.533z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.963.766v3.172h0H6.43V.766a.766.766 0 011.533 0zM4.506.766v3.172h0-1.533V.766a.766.766 0 011.533 0z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramMgt);
export default __webpack_public_path__ + "static/assets/diagramMgt.99128960.svg";
export { ForwardRef as ReactComponent };